import React from 'react'

import type { AgentChatMessage } from '~/api/agentChat'

import { AgentMessageBubble } from './AgentMessageBubble'
import { UserMessageBubble } from './UserMessageBubble'

export interface ChatMessageProps {
  isLastMessageInChat?: boolean
  isMostRecent?: boolean
  message: AgentChatMessage
  sessionId: string | null
}

const ChatMessage: React.FC<ChatMessageProps> = ({
  isLastMessageInChat = false,
  isMostRecent = false,
  message,
  sessionId,
}) => {
  if (!message.content && !message.attachments?.length && !message.isLoading) {
    return null
  }

  if (message.sender === 'user') {
    return <UserMessageBubble message={message} sessionId={sessionId} />
  }

  return (
    <AgentMessageBubble
      isLastMessageInChat={isLastMessageInChat}
      isMostRecent={isMostRecent}
      message={message}
      sessionId={sessionId}
    />
  )
}

export default ChatMessage
